export const en = {
    'set-context-price': 'Maximum CPM bid for new and changed impression criteria'
};
